import React, {useState} from 'react';
import {Controller, useForm} from "react-hook-form";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import moment from "moment";
import LoadingButton from "../../base/components/loadingButton";
import axios from "../../../helpers/axios";
import ApiSelect from "../../base/components/forms/apiSelect";
import {useLocation} from "react-router-dom";
import {Form} from "react-bootstrap";
import sayError from "../../../helpers/sayError";

const SearchForm = ({cb, one, url, grouped}) => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(false)
  const params = new URLSearchParams(search)
  const defaultVal= {
    start: params.get('start') || moment().subtract(7, 'days').format('DD.MM.YYYY'),
    end: params.get('end') || moment().format('DD.MM.YYYY'),
    counterparty: params.get('id') || '',
    uncompleted: params.get('unComp') === 'true'
  }

  const formController = useForm({defaultValues:defaultVal})
  const {handleSubmit,
    register,
    control} = formController

  const onSubmit = (dataF) => {
    setLoading(true)
    const payload = {
      ...dataF,
      uncompleted: !!dataF.uncompleted
    }
    if (one) {
      payload.groupBySupplier = !!grouped
    }
    axios.post(url, payload).then((resp)=>{
      cb(resp.data, payload)
    })
      .catch(sayError)
      .finally(()=>setLoading(false))
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={'d-flex align-items-center gap-2'}>
      <Form.Label className={'d-flex align-items-center gap-2'}>
        <input
          defaultChecked={defaultVal.uncompleted}
          {...register(`uncompleted`)}
          type={"checkbox"}
        />
        Непроведенные
      </Form.Label>
      <CustomDatePicker formController={formController}
                        label={"Дата c"}
                        value={defaultVal.start}
                        name={`start`}
                        rules={{required: true}}/>
      <CustomDatePicker formController={formController}
                        label={"Дата по"}
                        value={defaultVal.end}
                        name={`end`}
                        rules={{required: true}}/>
      {one && <div style={{width:200}} ><Controller
        control={control}
        render={({ field: { onChange, value } }) => (
          <ApiSelect
            value={value}
            label={'Контрагент'}
            url={"/api/counterparty/searchInput"}
            cb={newVal => onChange(newVal)}
          />
        )}
        name={`counterparty`}
      /></div>}
      <LoadingButton loading={loading} title={'Получить'}/>

    </form>
  );
};

export default SearchForm;
